import React, { useEffect, useState } from 'react';

import CardUi from '../components/common/Card';
import { useSkyContext } from '../store/provider';
import {Divider} from "antd";

const Trends: React.FC = () => {
  const skyContext = useSkyContext();
  const [items1, setItems1] = useState([
      'Flight life-cycle with correlation',
      'Lowest price - distribution by competitor',
  ]);
  const [items2, setItems2] = useState([
      'Competitive price trend',
      'Price vs. market trend',
      'Pricing groups - distribution by price range'
  ]);
  const [items3, setItems3] = useState([
      'Velocity of price changes at flights',
      'Inventory evolution - comparative snapshot',
      'Quarterly price & performance'
  ]);

  useEffect(() => {
  }, []);

  return (
      <>
      <Divider style={{marginBottom:0}}>
          <h3 style={{ fontSize: '30px', fontWeight: 'bold', fontFamily: 'Arial, sans-serif', color: 'rgb(3 55 120)', letterSpacing: '0.5px' }}>Trends & Performance</h3>
      </Divider>
    <div
      style={{
        margin: '60px auto',
        display: 'flex',
        gap: '3rem',
        flexDirection: 'column',
      }}
    >
      {(skyContext?.user?.user_type === 'admin' && (
        <div>
          <CardUi items={items1} title="Key business metrics trend" />
            <CardUi items={items2} title="Choose one of price trend reports" />
            <CardUi items={items3} title="Choose one of the count reports" />

        </div>
      )) ||
        'No permissions, please contact admin'}
    </div>
  </>);
};

export default Trends;
